/**
 * PlatformMetrics - Platform Activity section
 */
import React from 'react';
import { Activity, Target, BarChart3, Users } from 'lucide-react';
import { MetricCard, MetricSection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function PlatformMetrics({ snapshotData }) {
  const platformStats = snapshotData?.platformStats || {};
  
  return (
    <MetricSection title="Platform Activity">
      <MetricGrid cols={4}>
        <MetricCard
          icon={Activity}
          iconColor="bg-blue-100 dark:bg-blue-900/20"
          title="Total Survey Videos"
          value={formatValue(platformStats.totalSurveyVideos || 0, 'decimal')}
        />
        <MetricCard
          icon={Target}
          iconColor="bg-green-100 dark:bg-green-900/20"
          title="Total Campaigns"
          value={formatValue(platformStats.totalCampaigns || 0, 'decimal')}
        />
        <MetricCard
          icon={BarChart3}
          iconColor="bg-purple-100 dark:bg-purple-900/20"
          title="Template Usage"
          value={formatValue(platformStats.totalTemplateEdits || 0, 'decimal')}
        />
        <MetricCard
          icon={Activity}
          iconColor="bg-orange-100 dark:bg-orange-900/20"
          title="Stock Video Downloads"
          value={formatValue(platformStats.stockVideoDownloads || 0, 'decimal')}
        />
        <MetricCard
          icon={Activity}
          iconColor="bg-red-100 dark:bg-red-900/20"
          title="Video Template Usage"
          value={formatValue(platformStats.videoTemplateEdits || 0, 'decimal')}
        />
        <MetricCard
          icon={Users}
          iconColor="bg-yellow-100 dark:bg-yellow-900/20"
          title="Templates Edited"
          value={formatValue(platformStats.totalTemplateEdits || 0, 'decimal')}
        />
        <MetricCard
          icon={BarChart3}
          iconColor="bg-indigo-100 dark:bg-indigo-900/20"
          title="Total Template Page Hits"
          value={formatValue(platformStats.totalTemplatePageHits || 0, 'number')}
        />
        <MetricCard
          icon={Activity}
          iconColor="bg-gray-100 dark:bg-gray-800"
          title="Pending Reviews"
          value="0"
        />
      </MetricGrid>
    </MetricSection>
  );
}

